import React from 'react'
import Badge from '@material-ui/core/Badge'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  emitted: {
    '& .MuiBadge-badge': {
      backgroundColor: '#4caf50',
      color: '#fff',
      position: 'relative',
      transform: 'none',
    },
  },
  error: {
    '& .MuiBadge-badge': {
      backgroundColor: '#f44336',
      color: '#fff',
      position: 'relative',
      transform: 'none',
    },
  },
})

const STATE_LABELS: Record<string, string> = {
  Emitted: 'Emitida',
  Error: 'Error',
}

interface Props {
  state?: string
}

export default function DocumentStateBadge({ state }: Props) {
  const classes = useStyles()

  if (!state) return <>-</>

  const label = STATE_LABELS[state] ?? state
  const badgeClass = state === 'Emitted' ? classes.emitted : state === 'Error' ? classes.error : undefined

  return (
    <Badge
      className={badgeClass}
      badgeContent={label}
      color="default"
    >
      <span />
    </Badge>
  )
}
